export default {
  namespaced: true,
  state: () => ({
    token: "",
    userId: "",
    userCode: "",
    userName: "",
    userRole: "",
    storeId: "",
    storeCode: "",
    storeName: "",
    roleCode: "",
    roleName: "",
    icon: "",
    securityLevel: "",
    fieldSecurityLevel: "",
    menus: "",
    startMenus: "",
    menu: "/",
    doctorType: "",
    pharmacistType: "",
    baseUserId: "" // 新增
  }),
  actions: {
    login({ commit }, params) {
      commit('setToken', params.token)
      commit('setUserId', params.userId)
      commit('setUserCode', params.userCode)
      commit('setUserName', params.userName)
      commit('setUserRole', params.userRole)
      commit('setStoreId', params.storeId)
      commit('setStoreCode', params.storeCode)
      commit('setStoreName', params.storeName)
      commit('setRoleCode', params.roleCode)
      commit('setRoleName', params.roleName)
      commit('setSecurityLevel', params.securityLevel)
      commit('setFieldSecurityLevel', params.fieldSecurityLevel)
      commit('setDoctorType', params.doctorType)
      commit('setPharmacistType', params.pharmacistType)
      commit('setBaseUserId', params.baseUserId) // 新增
    },
    clear({ commit }) {
      commit('setToken', '')
      commit('setUserId', '')
      commit('setUserCode', '')
      commit('setUserName', '')
      commit('setUserRole', '')
      commit('setStoreId', '')
      commit('setStoreName', '')
      commit('setStoreRole', '')
      commit('setIcon', '')
      commit('setRoleCode', '')
      commit('setRoleName', '')
      commit('setSecurityLevel', '')
      commit('setFieldSecurityLevel', '')
      commit('setDoctorType', '')
      commit('setPharmacistType', '')
      commit('setBaseUserId', '') // 新增

      localStorage.removeItem('user.token')
      localStorage.removeItem('user.userId')
      localStorage.removeItem('user.userCode')
      localStorage.removeItem('user.userName')
      localStorage.removeItem('user.userRole')
      localStorage.removeItem('user.storeId')
      localStorage.removeItem('user.storeCode')
      localStorage.removeItem('user.storeName')
      localStorage.removeItem('user.icon')
      localStorage.removeItem('user.roleCode')
      localStorage.removeItem('user.roleName')
      localStorage.removeItem('user.securityLevel')
      localStorage.removeItem('user.fieldSecurityLevel')
      localStorage.removeItem('user.doctorType')
      localStorage.removeItem('user.pharmacistType')
      localStorage.removeItem('user.baseUserId') // 新增
    }
  },
  mutations: {
    setToken(state, token) {
      localStorage.setItem("user.token", token)
      state.token = token
    },
    setUserId(state, userId) {
      localStorage.setItem("user.userId", userId)
      state.userId = userId
    },
    setUserCode(state, userCode) {
      localStorage.setItem("user.userCode", userCode)
      state.userCode = userCode
    },
    setUserName(state, userName) {
      localStorage.setItem("user.userName", userName)
      state.userName = userName
    },
    setUserRole(state, userRole) {
      localStorage.setItem("user.userRole", userRole)
      state.userRole = userRole
    },
    setStoreId(state, storeId) {
      localStorage.setItem("user.storeId", storeId)
      state.storeId = storeId
    },
    setStoreCode(state, storeCode) {
      localStorage.setItem("user.storeCode", storeCode)
      state.storeCode = storeCode
    },
    setStoreName(state, storeName) {
      localStorage.setItem("user.storeName", storeName)
      state.storeName = storeName
    },
    setIcon(state, icon) {
      localStorage.setItem("user.icon", icon)
      state.icon = icon
    },
    setRoleCode(state, roleCode) {
      localStorage.setItem("user.roleCode", roleCode)
      state.roleCode = roleCode
    },
    setRoleName(state, roleName) {
      localStorage.setItem("user.roleName", roleName)
      state.roleName = roleName
    },
    setSecurityLevel(state, securityLevel) {
      localStorage.setItem("user.securityLevel", securityLevel)
      state.securityLevel = securityLevel
    },
    setFieldSecurityLevel(state, fieldSecurityLevel) {
      localStorage.setItem("user.fieldSecurityLevel", fieldSecurityLevel)
      state.fieldSecurityLevel = fieldSecurityLevel
    },
    setMenus: (state, menus) => {
      menus = JSON.stringify(menus)
      localStorage.setItem("user.menus", menus)
      state.menus = menus
    },
    setUserGroupList: (state, userGroupList) => {
      localStorage.setItem("user.userGroupList", userGroupList)
      state.userGroupList = userGroupList
    },
    setUserList: (state, userList) => {
      localStorage.setItem("user.userList", userList)
      state.userList = userList
    },
    setOnLineuserGroupList: (state, onLineuserGroupList) => {
      localStorage.setItem("user.onLineuserGroupList", onLineuserGroupList)
      state.onLineuserGroupList = onLineuserGroupList
    },
    setMessageGroupList: (state, messageGroupList) => {
      localStorage.setItem("user.messageGroupList", messageGroupList)
      state.messageGroupList = messageGroupList
    },
    setResponseMessageList: (state, responseMessageList) => {
      localStorage.setItem("user.responseMessageList", responseMessageList)
      state.responseMessageList = responseMessageList
    },
    setRequestMessageList: (state, requestMessageList) => {
      localStorage.setItem("user.requestMessageList", requestMessageList)
      state.requestMessageList = requestMessageList
    },
    setDoctorType: (state, doctorType) => {
      localStorage.setItem("user.doctorType", doctorType)
      state.doctorType = doctorType
    },
    setPharmacistType: (state, pharmacistType) => {
      localStorage.setItem("user.pharmacistType", pharmacistType)
      state.pharmacistType = pharmacistType
    },
    // 新增
    setBaseUserId: (state, baseUserId) => {
      localStorage.setItem("user.baseUserId", baseUserId)
      state.baseUserId = baseUserId
    }
  },
  getters: {
    getToken(state) {
      if (state.token === "") {
        state.token = localStorage.getItem("user.token")
      }
      return state.token
    },
    getUserId(state) {
      if (state.userCode === "") {
        state.userCode = localStorage.getItem("user.userId")
      }
      return state.userCode
    },
    getUserCode(state) {
      if (state.userCode === "") {
        state.userCode = localStorage.getItem("user.userCode")
      }
      return state.userCode
    },
    getUserName(state) {
      if (state.userName === "") {
        state.userName = localStorage.getItem("user.userName")
      }
      return state.userName
    },
    getStoreId(state) {
      if (state.storeId === "") {
        state.storeId = localStorage.getItem("user.storeId")
      }
      return state.storeId
    },
    getStoreCode(state) {
      if (state.storeCode === "") {
        state.storeCode = localStorage.getItem("user.storeCode")
      }
      return state.storeCode
    },
    getStoreName(state) {
      if (state.storeName === "") {
        state.storeName = localStorage.getItem("user.storeName")
      }
      return state.storeName
    },
    getUserRole(state) {
      if (state.userRole === "") {
        state.userRole = localStorage.getItem("user.userRole")
      }
      return state.userRole
    },
    getRoleCode(state) {
      if (state.roleCode === "") {
        state.roleCode = localStorage.getItem("user.roleCode")
      }
      return state.roleCode
    },
    getRoleName(state) {
      if (state.roleName === "") {
        state.roleName = localStorage.getItem("user.roleName")
      }
      return state.roleName
    },
    getSecurityLevel(state) {
      if (state.securityLevel === "") {
        state.securityLevel = localStorage.getItem("user.securityLevel")
      }
      return state.securityLevel
    },
    getFieldSecurityLevel(state) {
      if (state.fieldSecurityLevel === "") {
        state.fieldSecurityLevel = localStorage.getItem("user.fieldSecurityLevel")
      }
      return state.fieldSecurityLevel
    },
    getMenus(state) {
      if (state.menus === "") {
        state.menus = localStorage.getItem("user.menus")
      }
      return JSON.parse(state.menus)
    },
    getUserGroupList(state) {
      if (state.userGroupList === "") {
        state.userGroupList = localStorage.getItem("user.userGroupList")
      }
      return JSON.parse(state.userGroupList)
    },
    getUserList(state) {
      if (state.userList === "") {
        state.userList = localStorage.getItem("user.userList")
      }
      return JSON.parse(state.userList)
    },
    getOnLineuserGroupList(state) {
      if (state.onLineuserGroupList === "") {
        state.onLineuserGroupList = localStorage.getItem("user.onLineuserGroupList")
      }
      return JSON.parse(state.onLineuserGroupList)
    },
    getMessageGroupList(state) {
      if (state.messageGroupList === "") {
        state.messageGroupList = localStorage.getItem("user.messageGroupList")
      }
      return JSON.parse(state.messageGroupList)
    },
    getResponseMessageList(state) {
      if (state.responseMessageList === "") {
        state.responseMessageList = localStorage.getItem("user.responseMessageList")
      }
      return JSON.parse(state.responseMessageList)
    },
    getRequestMessageList(state) {
      if (state.requestMessageList === "") {
        state.requestMessageList = localStorage.getItem("user.requestMessageList")
      }
      return JSON.parse(state.requestMessageList)
    },
    getDoctorType: (state) => {
      if (state.doctorType === "") {
        state.doctorType = localStorage.getItem("user.doctorType")
      }
      return state.doctorType
    },
    getPharmacistType: (state) => {
      if (state.pharmacistType === "") {
        state.pharmacistType = localStorage.getItem("user.pharmacistType")
      }
      return state.pharmacistType
    },
    // 新增
    getBaseUserId: (state) => {
      if (state.baseUserId === "") {
        state.baseUserId = localStorage.getItem("user.baseUserId")
      }
      return state.baseUserId
    }
  }
}
